import { FirstName } from '@dreryk/person-name-common-api';

import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

type FirstNameFieldProps = {
   readonly register: FormContextValues['register'];
};

const FirstNameField = (props: FirstNameFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register('firstName', {
            required: true,
            maxLength: FirstName.MAX_LENGTH,
         })}
         label={'common:firstName'}
         testId={'firstName'}
      />
   );
};

export { FirstNameField };
